(() => {
  'use strict';
  if (window.avenorArrowIcons) return;
  window.avenorArrowIcons = true;
  const ns = 'http://www.w3.org/2000/svg';
  const paths = {
    '→':'M4 12h16M14 6l6 6-6 6', '←':'M20 12H4m6-6-6 6 6 6',
    '↗':'M5 19 19 5M5 5h14v14', '↘':'M5 5l14 14M5 19h14V5',
    '↑':'M12 20V4m-6 6 6-6 6 6', '↓':'M12 4v16m-6-6 6 6 6-6',
    '➜':'M4 12h16M14 6l6 6-6 6', '➡':'M4 12h16M14 6l6 6-6 6',
    '⬇':'M12 4v16m-6-6 6 6 6-6', '⬆':'M12 20V4m-6 6 6-6 6 6'
  };
  const match = /[→←↗↘↑↓➜➡⬇⬆]\uFE0F?/g;
  const forbidden = 'script,style,noscript,textarea,select,option,svg,math,[contenteditable="true"],[data-no-arrow-icons],#preview-bar-iframe';
  function convert(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(forbidden)) return;
    const text = node.nodeValue;
    match.lastIndex = 0;
    if (!match.test(text)) return;
    match.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const item of text.matchAll(match)) {
      fragment.append(document.createTextNode(text.slice(offset, item.index)));
      const svg = document.createElementNS(ns,'svg');
      svg.setAttribute('class','av-arrow-icon');
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('aria-hidden','true');
      svg.setAttribute('focusable','false');
      svg.setAttribute('fill','none');
      svg.setAttribute('stroke','currentColor');
      svg.setAttribute('stroke-width','1.6');
      svg.setAttribute('stroke-linecap','round');
      svg.setAttribute('stroke-linejoin','round');
      const path = document.createElementNS(ns,'path');
      path.setAttribute('d', paths[item[0][0]]);
      svg.append(path); fragment.append(svg);
      offset = item.index + item[0].length;
    }
    fragment.append(document.createTextNode(text.slice(offset)));
    node.replaceWith(fragment);
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) { convert(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(forbidden)) return;
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes=[]; let node;
    while ((node=walker.nextNode())) nodes.push(node);
    nodes.forEach(convert);
  }
  scan(document.body);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') convert(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.body,{subtree:true,childList:true,characterData:true});
})();